import { render, staticRenderFns } from "./IVRStatisticsResume.vue?vue&type=template&id=57aed1bc"
import script from "./IVRStatisticsResume.vue?vue&type=script&lang=ts"
export * from "./IVRStatisticsResume.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports